import { makeAutoObservable } from "mobx";
import { getTranslations } from "../api/translations";
import { setSelectedLocale } from "../utils/localStorage";

class TranslationsStore {
  constructor() {
    makeAutoObservable(this);
  }

  selectedLanguage: string = "en";
  translations: { [key: string]: string } = {};

  setSelectedLanguage(language: string): Promise<void> {
    setSelectedLocale(language);
    this.selectedLanguage = language;
    return getTranslations(language)
      .then((response) => {
        this.setTranslations(response.data);
      })
      .catch((e) => {
        console.log({ e });
      });
  }

  setTranslations(translations: { [key: string]: string }) {
    this.translations = translations;
  }
}

const translationsStore = new TranslationsStore();

export default translationsStore;
